<template>
  <div>
    <notifications></notifications>
    <navbar :show-navbar="showMenu">
      <div class="navbar-wrapper">
        <div class="navbar-toggle" :class="{ toggled: showMenu }">
          <navbar-toggle-button @click.native="toggleNavbar">
          </navbar-toggle-button>
        </div>
        <router-link class="navbar-brand" tag="a" to="/login">
            Vtool - ShopWare API
        </router-link>
      </div>

      <template slot="navbar-menu">
        <!-- <a
          href="https://www.creative-tim.com/product/vue-now-ui-dashboard-pro-laravel"
          target="_blank"
          class="btn nav-link nav-item mt-0"
          style="background-color: #f96332"
        >
          <i class="fas fa-download mr-2"></i>Purchase now</a
        >

        <a
          class="nav-item"
          tag="li"
          href="https://www.creative-tim.com/product/vue-now-ui-dashboard-pro-laravel"
          style="text-decoration: none"
          target="_blank"
        >
          <a class="nav-link">
            <i class="fas fa-download mr-2"></i>Purchase now..</a
          >
        </a> -->

        <router-link class="nav-item" tag="li" to="/dashboard">
          <a class="nav-link">
            <i class="now-ui-icons design_app"></i>
            Dashboard
          </a>
        </router-link>   

        <router-link class="nav-item" tag="li" to="/pricing">
          <a class="nav-link">
            <i class="now-ui-icons business_money-coins"></i>
            Pricing
          </a>
        </router-link>

        <router-link class="nav-item" tag="li" to="/register">
          <a class="nav-link">
            <i class="now-ui-icons tech_mobile"></i>
            Register
          </a>
        </router-link>

        <router-link class="nav-item" tag="li" to="/login">
          <a class="nav-link">
            <i class="now-ui-icons users_circle-08"></i>
            Login
          </a>
        </router-link>

        <router-link class="nav-item" tag="li" to="/documentation">
          <a class="nav-link">
            <i class="now-ui-icons files_single-copy-04"></i>
            Docu
          </a>
        </router-link>
      </template>
    </navbar>
    <div class="wrapper wrapper-full-page">
      <div
        class="full-page section-image"
        :class="pageClass"
        filter-color="black"
        data-image="/img/bg13.jpg"
      >
        <div class="content">
          <div class="container">
            <zoom-center-transition
              :duration="pageTransitionDuration"
              mode="out-in"
            >
              <router-view></router-view>
            </zoom-center-transition>
          </div>
        </div>
        <footer class="footer">
          <div class="container-fluid">
            <nav>
              <ul>
                <li class="nav-item">
                  <router-link class="nav-item" tag="a" to="/imprint">
                      Imprint
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-item" tag="a" to="/privacy">
                      Privacy
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-item" tag="a" to="/conditions">
                      Conditions
                  </router-link>
                </li>
                <li class="nav-item">
                   <router-link class="nav-item" tag="a" to="/documentation">
                      Docu
                  </router-link>
                </li>
              </ul>
            </nav>
            <div class="copyright">
              © {{ year }}, made with <i class="fa fa-heart heart"></i> by <a
                href="https://vuejs.org"
                class="font-weight-bold ml-1"
                target="_blank"
                rel="noopener"
                >VUE JS</a
              >, 
              <a
                href="https://vuetifyjs.com/"
                class="font-weight-bold ml-1"
                target="_blank"
                rel="noopener"
                >VUETIFY JS</a
              >
              and<a
                href="https://laravel.com"
                class="font-weight-bold ml-1"
                target="_blank"
                rel="noopener"
                >Laravel</a
              >
              for a better web.
            </div>
          </div>
        </footer>

        <div
          class="full-page-background"
          style="background-image: url('/img/bg13.jpg')"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import { Navbar, NavbarToggleButton } from "src/components";
import { ZoomCenterTransition } from "vue2-transitions";

export default {
  components: {
    Navbar,
    NavbarToggleButton,
    ZoomCenterTransition,
  },
  props: {
    backgroundColor: {
      type: String,
      default: "black",
    },
  },
  data() {
    return {
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 200,
      year: new Date().getFullYear(),
      pageClass: "login-page",
    };
  },
  mounted () {
    if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
      console.log("It's a local server! CookieBot in SidebarSharePlugin.vue...");
    } else {
      this.$cookiebot.consentBanner();
    }
  },
  methods: {
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      this.showMenu = false;
    },
    setPageClass() {
      this.pageClass = `${this.$route.name}-page`.toLowerCase();
    },
  },
  beforeDestroy() {
    this.closeMenu();
  },
  beforeRouteUpdate(to, from, next) {
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu();
      setTimeout(() => {
        next();
      }, this.menuTransitionDuration);
    } else {
      next();
    }
  },
  watch: {
    $route() {
      this.setPageClass();
    },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.8;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}
.wrapper-full-page .zoomIn {
  animation-name: zoomIn8;
}
@keyframes zoomOut8 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.wrapper-full-page .zoomOut {
  animation-name: zoomOut8;
}
</style>
